import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

const TOPIC_LIST_KEYS = [
  'BRAND_NAME',
  'COMPANY_NAME',
  'CNPJ',
];

function SectionChannelsOverview() {
  return (
    <Box
      tag="section"
      paddingHorizontal={{ xs: '0x', md: '8x', lg: '12x' }}
      paddingVertical={{ xs: '8x', md: '8x', lg: '8x' }}
    >
      <div>
        <Grid row spacing={{ xs: '0x', md: '4x' }}>
          <Grid col={{ xs: 12, md: 8, lg: 12 }}>
            <Box
              marginTop={{ xs: '8x', md: '16x', lg: '12x' }}
              paddingHorizontal={{ xs: '6x', md: 0 }}
            >
              <Grid row tag="ul" spacing={0}>
                {
                  TOPIC_LIST_KEYS.map((key, index) => (
                    <Grid key={key} tag="li" col={{ xs: 12, lg: 4 }}>
                      <Box
                        marginTop={{ xs: index ? '8x' : '0x', lg: index < 3 ? '0x' : '8x' }}
                        paddingRight={{ lg: index % 2 ? '0x' : '4x' }}
                        paddingLeft={{ lg: index % 2 ? '4x' : '0x' }}
                      >
                        <Typography
                          variant="subtitle"
                          color="black"
                          intlKey={`SERVICE_CHANNELS.OVERVIEW.${key}.TITLE`}
                          gutterBottom={0.5}
                        />
                        <Typography
                          intlKey={`SERVICE_CHANNELS.OVERVIEW.${key}.TEXT`}
                        />
                      </Box>
                    </Grid>
                  ))
                }
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}

export default React.memo(SectionChannelsOverview);
